import * as Yup from "yup";
import { COMPANY_REGISTRATION_TYPE_ARRAY } from "../../../../Menu/util/constants"
export function getValidation(stepName) {
  const validationSchemas = {
    organization: Yup.object({
      ein: Yup.string()
        .length(9, "Company EIN must be 9 digits in length")
        .required("Company EIN is required"),
      registrationType: Yup.string()
        .oneOf(COMPANY_REGISTRATION_TYPE_ARRAY, "Select an Ownership Type")
        .required("Ownership Type is required"),
      registrationState: Yup.string().required(
        "State of Registration is required",
      ),
      displayName: Yup.string()
        .trim()
        .min(1, "Display Name is required")
        .required("Display Name is required"),
      website: Yup.string()
        .nullable()
        .notRequired()
        .test("url", "Enter a valid website", (value) => {
          if (!value || value.trim() === "") return true;
          const regex =
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i;
          return regex.test(value);
        }),
    }),

    address: Yup.object({
      addressLine1: Yup.string().required("Street address is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      zip: Yup.string()
        .min(5, "ZIP must be 5 to 9 digits")
        .max(9, "ZIP must be 5 to 9 digits")
        .required("ZIP code is required"),
    }),
    contact: Yup.object({
      contactFirstName: Yup.string().required("Contact first name is required"),
      contactLastName: Yup.string().required("Contact last name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Contact email is required"),
      phone: Yup.string().required("Contact phone is required"),
    }),
    admin: Yup.object({
      rootAdminEmail: Yup.string()
        .email("Invalid email address")
        .required("Admin email is required"),
      rootAdminPhone: Yup.string().required("Admin phone is required"),
      rootAdminFirstName: Yup.string().required("Admin first name is required"),
      rootAdminLastName: Yup.string().required("Admin last name is required"),
    }),
  };

  const normalizedStepName =
    typeof stepName === "string"
      ? stepName.trim().toLowerCase().replace(/\s+/g, "_")
      : undefined;

  return {
    validationSchema: validationSchemas[normalizedStepName] || Yup.object({}),
  };
}

export default getValidation;
